<template>
  <v-radio-group @change="onChange" v-model="semesterData" row class="shrink my-0" hide-details>
    <v-radio label="Học kỳ I" hide-details value="semester-1"></v-radio>
    <v-radio label="Học kỳ II" hide-details value="semester-2"></v-radio>
    <v-radio label="Cả năm" hide-details value="year"></v-radio>
  </v-radio-group>
</template>

<script>
import { Semester } from '@/plugins/api'
import { mapState } from 'vuex'
import { orderBy } from 'lodash'

export default {
  data: () => ({
    semesterData: '',
    semesterFilter: '',
    semesters: []
  }),
  props: {
    schoolYear: Object
  },
  created() {
    this.loadData()
  },
  computed: {
    ...mapState('app', ['currentSemester'])
  },
  methods: {
    async loadData() {
      const semesters = await Semester.fetch({ schoolYear: this.schoolYear.id })
      this.semesters = orderBy(semesters, ['type'], ['asc'])
      this.semesterData = this.currentSemester.type
      if (this.semesterData === 'semester-1') this.semesterFilter = this.semesters[0]
      else this.semesterFilter = this.semesters[1]

      this.$emit('change', this.semesterFilter)
    },
    onChange(data) {
      if (data === 'semester-1') this.semesterFilter = this.semesters[0]
      else if (data === 'semester-2') this.semesterFilter = this.semesters[1]
      else this.semesterFilter = { semesters: this.semesters, type: 'year' }

      this.$emit('change', this.semesterFilter)
    }
  }
}
</script>
